/**
 * Formatting utilities for data sources
 */

import { formatRelativeTime } from "@/lib/utils";

/**
 * Format a date value for display
 */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return 'N/A';
  return formatRelativeTime(value);
}

/**
 * Format an array for display
 */
export function formatArray(value: any[] | null | undefined, separator: string = ', '): string {
  if (!value || !Array.isArray(value)) return 'N/A';
  if (value.length === 0) return 'Empty';
  return value.map(String).join(separator);
}

/**
 * Format a boolean for display
 */
export function formatBoolean(value: boolean | null | undefined): string {
  if (value === null || value === undefined) return 'N/A';
  return value ? 'Yes' : 'No';
}

/**
 * Format a string with a fallback
 */
export function formatString(value: string | null | undefined, fallback: string = 'N/A'): string {
  return value || fallback;
}

/**
 * Format a number with optional decimal places
 */
export function formatNumber(value: number | null | undefined, decimals?: number): string {
  if (value === null || value === undefined) return 'N/A';
  return decimals !== undefined ? value.toFixed(decimals) : String(value);
}

/**
 * Format tags array for display
 */
export function formatTags(tags: string[] | null | undefined): string {
  if (!tags || !Array.isArray(tags) || tags.length === 0) {
    return 'No tags';
  }
  return tags.join(', ');
}

/**
 * Format version object or number
 */
export function formatVersion(version: any): string {
  if (!version) return '0';
  if (typeof version === 'number') return String(version);
  if (typeof version === 'object' && 'major' in version) {
    return `${version.major}.${version.minor || 0}.${version.patch || 0}`;
  }
  return String(version);
}

/**
 * Format section count
 */
export function formatSectionCount(data: any[] | null | undefined): string {
  const count = data?.length || 0;
  return `${count} section${count !== 1 ? 's' : ''}`;
}

